// extracted by mini-css-extract-plugin
module.exports = {"paxesWrapper":"styles_paxesWrapper____U35"};